// extracted by mini-css-extract-plugin
module.exports = {"KeyValueRow":"KeyValueRow_KeyValueRow__1UIGC","title":"KeyValueRow_title__8kYtz","value":"KeyValueRow_value__1TJgk"};